/** 
 * Builds an array starting from the min to the max, stepping by the accum amount each step
 * 
 * @param {number} min   the minimum allowed value
 * @param {number} max   the maximum allowed value
 * @param {number} accum the amount each step in the range accumulates
 * 
 * @return {number[]}
 */
function range(min, max, accum = 1) {
  const total = Math.ceil((max - min) / accum);
  const arr = new Array(total);

  for (let i = 0; i < total; i++) {
    arr[i] = min + (accum * i);
  }

  return arr;
}

export default range;